import React from 'react';
import {useSelector} from 'react-redux'
import * as S from './GoSafeZone.styles';
import Icon from '../../../../../stories/core-components/IconsSelector';
import {srpRawDataSelector} from './../../../../containers/SRP/redux/selectors';
const GoSafeZoneCard = props => {

  const {rawData} = useSelector(srpRawDataSelector);
  const {message}  = rawData;
  if(!message || !Object.keys(message).length){
    return null;
  }
  return (
    <S.GoSafeZone>
      <S.Content>
        <img src={message.l} alt="" width="30px" />

        <S.Info>
       {message.i}
        </S.Info>
      </S.Content>
      <button  onClick={()=>{
        window.open("https://www.goibibo.com/info/mysafety");
      }}>Learn more</button>
    </S.GoSafeZone>
  );
};

export default GoSafeZoneCard;
